import { createReducer } from '@reduxjs/toolkit'
import { CfrGroup } from 'interfaces/api/cfrGroups.interfaces'
import { ValidationErrorsApi } from 'packages/api'
import { createBuilder } from 'packages/redux-toolkit'

import {
  createCfrGroup,
  getAllCfrGroups,
  removeCfrGroup,
  setCfrGroupValidationErrors,
  setSingleCfrGroup,
  updateCfrGroup,
} from './actions'

interface CfrGroupsState {
  list: {
    loading: boolean
    items: CfrGroup[]
  }
  single: {
    loading: boolean
    item: CfrGroup | null
  }
  validation: ValidationErrorsApi | null
}

const initialState: CfrGroupsState = {
  list: {
    loading: false,
    items: [],
  },
  single: {
    loading: false,
    item: null,
  },
  validation: null,
}

export const cfrGroupsReducer = createReducer(initialState, (builder) => {
  createBuilder(builder)
    .addCase(getAllCfrGroups.pending, (state) => {
      state.list.loading = true
    })
    .addCase(getAllCfrGroups.rejected, (state) => {
      state.list.loading = false
    })
    .addCase(getAllCfrGroups.fulfilled, (state, { payload }) => {
      state.list.loading = false
      state.list.items = payload
    })

    .addCase(setCfrGroupValidationErrors, (state, { payload }) => {
      state.validation = payload
    })

    .addCase([setSingleCfrGroup], (state, { payload }) => {
      state.single.loading = false
      state.single.item = payload
    })

    .addCase([createCfrGroup.pending, removeCfrGroup.pending, updateCfrGroup.pending], (state) => {
      state.single.loading = true
    })
    .addCase([createCfrGroup.rejected, removeCfrGroup.rejected, updateCfrGroup.rejected], (state) => {
      state.single.loading = false
    })
    .addCase([createCfrGroup.fulfilled, removeCfrGroup.fulfilled, updateCfrGroup.fulfilled], (state) => {
      state.single.loading = false
    })
})
